import { useState, useEffect } from 'react';

export const useScreenSize = () => {
  const [itemsPerPage, setItemsPerPage] = useState(25);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setItemsPerPage(10);
      } else {
        setItemsPerPage(25);
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return itemsPerPage;
};
